import Layout from "../../../components/Layout";
import UserViewAvisos from "../Dashboard/userViewAvisos";

export default function Avisos() {
  return Layout(UserViewAvisos, "Avisos");
}
